import { formatHtml } from "@trumpf/ux.common-storybook";
import {
    dummyPage,
    TeaserPageTemplate,
    TeaserPageListTemplate,
} from "./teaser-page.templates";

export default {
    title: "Website/Partial Templates/Teaser/Page",
    render: TeaserPageTemplate.bind({}),
    parameters: {
        docs: {
            source: {
                transform: formatHtml,
            },
        },
    },
    args: { ...dummyPage },
};

export const Default = {};

export const List = {
    render: TeaserPageListTemplate.bind({}),
};
